import EndPointConfig from '../../models/api/endPointConfig';

const controller: string = 'Rewards';

export const RewardsEP2: EndPointConfig[] = [
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setActionName('filtered/earned')
        .setAlias('GetRewardsEarnedFiltered'),
    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)
        .setPattern('earned/{id}')
        .setAlias('DeleteRewardEarned'),
];
